module.exports = __webpack_public_path__ + "static/media/cornell-badge.d76284d5.svg";